module.exports = __webpack_public_path__ + "img/3.d54ff12c.png";